import { getPlatformComponent } from '@direct-frontend/platform-code';
import { ComponentType } from 'react';

import { MenuTriggerProps } from './types';

/**
 * Компонент для создания меню, открывающегося по нажатию.
 * @example
 * ```tsx
 * <MenuTrigger trigger={props => <Button {...props} ref={castRef(props.ref, 'button')}>Open menu</Button>}>
 *     <List size="m">
 *         <ListItem>Item 1</ListItem>
 *         <ListItem>Item 2</ListItem>
 *     </List>
 * </MenuTrigger>
 * ```
 */
export const MenuTrigger = getPlatformComponent<ComponentType<MenuTriggerProps>>({
    desktop: import('./MenuTrigger@desktop'),
    mobile: import('./MenuTrigger@mobile'),
});
